import { React, useEffect, useState } from 'react';
// import GeoGebraP from '../components/GeoGebraP';
import { useParams, useNavigate } from 'react-router-dom';
// import '../App.css';
// import GetProblemInfo from '../components/GetProblemInfo';
import axiosapi from "../api/axiosapi";
// import ProblemStatDescription from '../components/ProblemStatDescription';
// import useAuth from '../hooks/useAuth';
// import UserSolvingStat from '../components/UserSolvingStat';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
// import { Helmet } from 'react-helmet';
import { Helmet } from 'react-helmet-async';
import useAuth from '../hooks/useAuth';


const DoorImproveAbility = ()=> {
    const {improveAbilityDoorURL}=useParams();
    const navigateto = useNavigate();
    // const {todayProblemList, todayProblem} = useLocation().state;
    // const location = useLocation();
    // const {auth} = useAuth();
    const [brainUpInfo, setBrainUpInfo] = useState('');
    const [brainUpStory, setBrainUpStory] = useState([]);
    const { setAuth } = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect (() => {
        const fetchToken = async () => {
            try {
                    const response = await axiosapi.post('/refresh-token', {
                                    withCredentials: true
                            });
                    setAuth(prev => {
                            // console.log(JSON.stringify(prev));
                            // console.log(response.data.access_token);
                            return { 
                            ...prev, 
                            userRole1: response.data.userRole1,
                            userRole2: response.data.userRole2,
                            accessToken: response.data.access_token 
                            }
                    });
            } catch {
                    setAuth(prev => {
                            // console.log(JSON.stringify(prev));
                            // console.log(response.data.access_token);
                            return { 
                            ...prev, 
                            accessToken: null 
                            }
                    }); // 로그인 안 된 상태
            } finally {
                    setLoading(false);
            }
        }
        
        const getBrainUpInfo = async () => {
            try {
                const response = await axiosapi.get('/door/improveability/', {
                    params: {
                        url: improveAbilityDoorURL
                    },
                    withCredentials: true
                })
                response.data && setBrainUpInfo(response.data);
                const brainUpStoryD = response.data && response.data.brainUpStory && response.data.brainUpStory.split("|");
                setBrainUpStory(brainUpStoryD);
            } catch (err) {
                console.log(err);
            }
        }

        fetchToken();
        getBrainUpInfo();
    }, [improveAbilityDoorURL])

    brainUpInfo.categoryCode && navigateto(`/improvemathability/${brainUpInfo.categoryCode}`, {state:{
            "categoryCode": brainUpInfo.categoryCode,
            "problemCode": brainUpInfo.firstProblemCode,
            "improveAbilityTitle": brainUpInfo.brainUpTitle,
            "improveAbilityType": brainUpInfo.brainUpType
        }});

    // const splitContent = (sentence) => {
    //     const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
    //     const matches = sentence.matchAll(InlineMathRegex);
    //     let lastIndex = 0;
    //     const contentArray = [];
      
    //     for (const match of matches) {
    //         const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
    //         const restOfContent = sentence.substring(lastIndex, match.index);
        
    //         contentArray.push(restOfContent, InlineMathContent);
    //         lastIndex = match.index + match[0].length;
    //     }
      
    //     if (lastIndex < sentence.length) {
    //         contentArray.push(sentence.substring(lastIndex));
    //     }
      
    //     return <div>{contentArray}</div>;
    // };

    // return(
    //     <div className="App-full-container" key={improveAbilityDoorURL}>
    //         <Helmet>
    //             <title>{brainUpInfo.brainUpTitle && "티프매쓰: "+brainUpInfo.brainUpTitle}</title>
    //             <meta name="description" content={brainUpInfo.brainUpDescription  && brainUpInfo.brainUpDescription} />
    //             <meta property="og:title" content={brainUpInfo.brainUpTitle && brainUpInfo.brainUpTitle} />
    //             <meta property="og:description" content={brainUpInfo.brainUpDescription  && brainUpInfo.brainUpDescription} />
    //             <meta property="og:url" content={"https://tiffmath.com/door/brainup/"+improveAbilityDoorURL} />
    //             <meta property="og:type" content="website" />
    //             <meta property="og:image" content={"https://tiffmath.com/image/"+brainUpInfo.imageFileName} />
    //         </Helmet>
    //         <div className="position-center-box-2-1">
    //             <h5 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px"}}>{brainUpInfo.brainUpTitle}</h5>

    //             {<div style={{marginLeft:"5px"}}>
    //                 {brainUpInfo.brainUpDescription  && splitContent(brainUpInfo.brainUpDescription)}

    //             </div>}
                
    //             <div style={{marginLeft:"5px"}}>
    //                 {brainUpInfo.brainUpStory && <button 
    //                     className='button' 
    //                     onClick={() => navigateto(`/improvemathability/${brainUpInfo.categoryCode}`, {state:{
    //                         "categoryCode": brainUpInfo.categoryCode,
    //                         "problemCode": brainUpInfo.firstProblemCode,
    //                         "improveAbilityTitle": brainUpInfo.brainUpTitle,
    //                         "improveAbilityType": brainUpInfo.brainUpType
    //                     }})}
    //                 >
    //                     바로 두뇌 활성화 문제 풀어보기
    //                 </button>}
    //                 {brainUpInfo.brainUpStory && <div>
    //                     <br/>
    //                     <br/>
    //                 </div>}

    //                 {/* <p style={{marginLeft:"5px"}}>{brainUpInfo.publicationDate}</p> */}

    //                 {brainUpInfo.brainUpStory && brainUpInfo.brainUpStoryTitle && <b><p>{splitContent(brainUpInfo.brainUpStoryTitle)}</p></b>}

    //                 {brainUpInfo.imageFileName && <img src={`/image/${brainUpInfo.imageFileName}`} style={{width:'95%', marginBottom:'10px'}} />}
    //                 <br/>                
    //                 {brainUpInfo.brainUpStory && brainUpStory.map(item => (<div><p>{splitContent(item)}</p></div>))}

    //                 <button 
    //                     className='button' 
    //                     onClick={() => navigateto(`/improvemathability/${brainUpInfo.categoryCode}`, {state:{
    //                         "categoryCode": brainUpInfo.categoryCode,
    //                         "problemCode": brainUpInfo.firstProblemCode,
    //                         "improveAbilityTitle": brainUpInfo.brainUpTitle,
    //                         "improveAbilityType": brainUpInfo.brainUpType
    //                     }})}
    //                 >
    //                     두뇌 활성화 문제 풀어보기
    //                 </button>
    //             </div>
    //         </div>
    //     </div>
    // );
};

export default DoorImproveAbility;
